import { MeasureValues, useModelService } from 'services/model/model.service';
import { MeasureBreakdownList, MeasureBreakdownRow } from 'components/profitability/MeasureBreakdownList';

interface FeesListProps {
  values?: MeasureValues;
  compareValues?: MeasureValues;
  isComparisonActive: boolean;
}

export function FeesList({ values = undefined, compareValues = undefined, isComparisonActive }: FeesListProps) {
  const { getMeasures, getMeasuresByMetrics } = useModelService();
  const [itemMkpFeeVal, itemPayFeeVal] = getMeasures(['itemNetSlsMkpFeeValExtExpOD', 'itemSlsPayFeeValOD']);
  const [payFeeRate] = getMeasuresByMetrics(['slsPayFeeRate'], 'OD');
  const [mkpFeeVal, mkpFeeRate, payFeeVal, feeVal, feeRate] = getMeasures([
    'netSlsMkpFeeValExtExpOD',
    'netSlsMkpFeeRateExtExpOD',
    'slsPayFeeValOD',
    'netSlsFeeValExtExpOD',
    'netSlsFeeRateExtExpOD',
  ]);

  const rows: MeasureBreakdownRow[] = [
    {
      labelMeasure: mkpFeeVal,
      perItemMeasure: itemMkpFeeVal,
      totalMeasure: mkpFeeVal,
      shareMeasure: mkpFeeRate,
    },
    {
      labelMeasure: payFeeVal,
      perItemMeasure: itemPayFeeVal,
      totalMeasure: payFeeVal,
      shareMeasure: payFeeRate,
    },
    {
      labelMeasure: feeVal,
      totalMeasure: feeVal,
      shareMeasure: feeRate,
      isTotal: true,
    },
  ];

  return (
    <MeasureBreakdownList
      titleMeasure={feeVal}
      rows={rows}
      values={values}
      compareValues={compareValues}
      isComparisonActive={isComparisonActive}
      testId="profitability-fees-list"
    />
  );
}
